import Konva from 'konva'
import Color from './color.es6'
import Ren from './ren-shape.es6'
import Geo from './geometrics.es6'

function anchor (scale) {
  scale = scale || 1
  const stroke = Color.tBlueDark
  const fill = Color.tBlue
  const strokeWidth = 0.5
  const opacity = 1

  const shapes = []
  shapes.push(
    new Ren.Rect({
      x: -6 / scale,
      y: -6 / scale,
      width: 12 / scale,
      height: 12 / scale,
      stroke: stroke,
      strokeWidth: strokeWidth / scale,
      fill: fill,
      opacity: opacity
    })
  )
  return shapes
}

function wrap (renElementShapes, hover, scale) {
  scale = scale || 1
  const stroke = Color.tBlue
  const strokeWidth = (hover ? 1 : 3) / scale
  const opacity = 1

  const shapes = []

  const xs = []
  const ys = []

  renElementShapes.forEach(shape => {
    if (shape.className === 'Circle') {
      xs.push(shape.attrs.x - shape.attrs.radius, shape.attrs.x + shape.attrs.radius)
      ys.push(shape.attrs.y - shape.attrs.radius, shape.attrs.y + shape.attrs.radius)
    } else if (['Rect', 'Text'].includes(shape.className)) {
      xs.push(shape.attrs.x, shape.attrs.x + shape.getWidth())
      ys.push(shape.attrs.y, shape.attrs.y + shape.getHeight())
    } else if (shape.className === 'Line') {
      for (let i in shape.attrs.points) {
        if (i % 2 === 0) {
          // i is even (x-coordinate)
          xs.push(shape.attrs.points[i])
        } else {
          ys.push(shape.attrs.points[i])
        }
      }
    }
  })

  const padding = 2 / scale

  shapes.push(new Ren.Rect({
    x: Math.min(...xs) - padding,
    y: Math.min(...ys) - padding,
    width: Math.max(...xs) - Math.min(...xs) + 2 * padding,
    height: Math.max(...ys) - Math.min(...ys) + 2 * padding,
    stroke: stroke,
    strokeWidth: strokeWidth,
    fillEnabled: false,
    opacity: opacity
  }))

  return shapes
}

function hexToRgb (hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null
}

function isColorDark (hexColor) {
  const rgb = hexToRgb(hexColor)
  if (rgb) {
    const brightness = Math.sqrt(
      rgb.r * rgb.r * 0.299 +
      rgb.g * rgb.g * 0.587 +
      rgb.b * rgb.b * 0.114)
    return brightness < 128
  }
  return undefined
}

function vectorWrap (renLine, hover) {
  const stroke = isColorDark(renLine.attrs.stroke) ? Color.tYellow : Color.tBlue
  const strokeWidth = hover ? 1 : 3
  const opacity = 1

  const shapes = []

  shapes.push(new Ren.Line({
    points: renLine.attrs.points,
    stroke: stroke,
    strokeWidth: strokeWidth,
    fillEnabled: false,
    opacity: opacity,
    closed: renLine.attrs.closed,
    tension: renLine.attrs.tension
  }))

  return shapes
}

function rotator (scale) {
  scale = scale || 1
  const stroke = Color.tBlueDark
  const fill = Color.tBlue
  const strokeWidth = 0.5
  const opacity = 1

  const shapes = []
  shapes.push(
    new Ren.Circle({
      x: 0,
      y: 0,
      radius: 6 / scale,
      stroke: stroke,
      strokeWidth: strokeWidth / scale,
      fill: fill,
      opacity: opacity
    })
  )
  return shapes
}

function rotateVector (scale) {
  scale = scale || 1
  const stroke = Color.tBlue
  const strokeWidth = 1 / scale
  const opacity = 0.5

  const shapes = []
  shapes.push(
    new Ren.Line({
      id: 'rotateVector',
      points: [0, -2000 / scale, 0, 2000 / scale],
      stroke: stroke,
      strokeWidth: strokeWidth,
      opacity: opacity,
      dash: [10 / scale, 5 / scale]
    })
  )
  return shapes
}

function selRect () {
  const shapes = []
  shapes.push(
    new Konva.Rect({
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      stroke: Color.black,
      strokeWidth: 1,
      fill: Color.tBlue,
      opacity: 0.25
    })
  )
  return shapes
}

function grid ({ span, extent, detailed, zoomLevel }) {
  // Detailed: major and minor lines. Not detailed: minor lines at the span of major.
  const major = { stroke: Color.black, strokeWidth: 0.5, opacity: 0.5 }
  const minor = { stroke: Color.black, strokeWidth: 0.2, opacity: 0.2 }

  const currentSpan = Geo.calculateCurrentGridSpan(span, zoomLevel, detailed)
  const shapes = []
  const linesExtent = Math.floor(extent / currentSpan) * currentSpan

  for (let i = -linesExtent; i <= linesExtent; i += currentSpan) {
    const format = detailed && i / currentSpan % Geo.majorGridSpan === 0 ? major : minor
    const { stroke, strokeWidth, opacity } = format

    shapes.push(new Konva.Line({ // horizontal
      points: [-extent, i, extent, i],
      strokeWidth: strokeWidth / zoomLevel,
      stroke,
      opacity
    }))
    shapes.push(new Konva.Line({ // vertical
      points: [i, -extent, i, extent],
      strokeWidth: strokeWidth / zoomLevel,
      stroke,
      opacity
    }))
  }
  return shapes
}

function bottom (gridExtent) {
  const shapes = []
  shapes.push(
    new Konva.Rect({
      x: -gridExtent,
      y: -gridExtent,
      width: gridExtent * 2,
      height: gridExtent * 2
    })
  )
  return shapes
}

export default { anchor, wrap, vectorWrap, rotator, rotateVector, selRect, grid, bottom }
